export default {"src":"/_next/static/media/whatsapp.1bdf202c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};